import { render, staticRenderFns } from "./MileageOdometerForm.vue?vue&type=template&id=12d00671"
import script from "./MileageOdometerForm.vue?vue&type=script&lang=js"
export * from "./MileageOdometerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports